import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';

const useOnFormChange = (formData: any) => {
    const config = useSelector((state: RootState) => state.common.config);

    /**
     * Bind the onFormChange config interface to the form change
     */
    useEffect(() => {
        config.onFormChange(formData);
    }, [formData]);
};

export default useOnFormChange;
